<template>
    <ul :class="gridClass">
        <li v-for="product in products" :key="product.slug">
            <WidgetProductCard :product="product" />
        </li>
    </ul>
</template>

<script lang="ts" setup>
import type { APIProduct } from "~~/shared/types/product";

interface Props {
    products: APIProduct[];
    // Responsive columns per breakpoint, defaults to { base: 2, md: 3, lg: 4 }
    columns?: Partial<Record<"base" | "sm" | "md" | "lg" | "xl" | "2xl", 1 | 2 | 3 | 4 | 5 | 6>>;
}
const props = defineProps<Props>();

const gridClass = computed(() => {
    const classes: Array<string | Record<string, boolean>> = ["grid", "gap-4"]; // base grid styles

    const cfg = {
        base: 2,
        md: 3,
        lg: 4,
        ...props.columns,
    } as Partial<Record<"base" | "sm" | "md" | "lg" | "xl" | "2xl", number>>;

    // Base (no prefix)
    classes.push({
        "grid-cols-1": cfg.base === 1,
        "grid-cols-2": cfg.base === 2,
        "grid-cols-3": cfg.base === 3,
        "grid-cols-4": cfg.base === 4,
        "grid-cols-5": cfg.base === 5,
        "grid-cols-6": cfg.base === 6,
    });

    // sm
    classes.push({
        "sm:grid-cols-1": cfg.sm === 1,
        "sm:grid-cols-2": cfg.sm === 2,
        "sm:grid-cols-3": cfg.sm === 3,
        "sm:grid-cols-4": cfg.sm === 4,
        "sm:grid-cols-5": cfg.sm === 5,
        "sm:grid-cols-6": cfg.sm === 6,
    });

    // md
    classes.push({
        "md:grid-cols-1": cfg.md === 1,
        "md:grid-cols-2": cfg.md === 2,
        "md:grid-cols-3": cfg.md === 3,
        "md:grid-cols-4": cfg.md === 4,
        "md:grid-cols-5": cfg.md === 5,
        "md:grid-cols-6": cfg.md === 6,
    });

    // lg
    classes.push({
        "lg:grid-cols-1": cfg.lg === 1,
        "lg:grid-cols-2": cfg.lg === 2,
        "lg:grid-cols-3": cfg.lg === 3,
        "lg:grid-cols-4": cfg.lg === 4,
        "lg:grid-cols-5": cfg.lg === 5,
        "lg:grid-cols-6": cfg.lg === 6,
    });

    // xl
    classes.push({
        "xl:grid-cols-1": cfg.xl === 1,
        "xl:grid-cols-2": cfg.xl === 2,
        "xl:grid-cols-3": cfg.xl === 3,
        "xl:grid-cols-4": cfg.xl === 4,
        "xl:grid-cols-5": cfg.xl === 5,
        "xl:grid-cols-6": cfg.xl === 6,
    });

    // 2xl
    classes.push({
        "2xl:grid-cols-1": cfg["2xl"] === 1,
        "2xl:grid-cols-2": cfg["2xl"] === 2,
        "2xl:grid-cols-3": cfg["2xl"] === 3,
        "2xl:grid-cols-4": cfg["2xl"] === 4,
        "2xl:grid-cols-5": cfg["2xl"] === 5,
        "2xl:grid-cols-6": cfg["2xl"] === 6,
    });

    return classes;
});
</script>

<style></style>
